import clsx from 'clsx';

import { FieldWrapper } from './FieldWrapper';

export const SelectField = (props) => {
  const {
    label,
    options,
    error,
    className,
    caption,
    defaultValue,
    registration,
    placeholder,
    onChange,
  } = props;
  return (
    <FieldWrapper label={label} error={error}>
      <select
        placeholder={placeholder}
        name="location"
        className={clsx(
          'mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md',
          className
        )}
        defaultValue={defaultValue}
        {...registration}
        onChange={onChange}
      >
        {options.map(({ label, value }) => (
          <option key={label?.toString()} value={value}>
            {label}
          </option>
        ))}
      </select>
      <span className="text-xs">{caption}</span>
    </FieldWrapper>
  );
};
